export const dotenv = {
  API_BASE_URL: 'https://api-dev.mykinships.com',
  NOTIFICATION_BASE_URL: 'https://api-dev-notification.mykinships.com',
  FRONTEND_BASE_URL: 'https://app-dev.mykinships.com',
  MEDIA_BASE_URL: 'https://api-dev-media.mykinships.com',
  NODE_TLS_REJECT_UNAUTHORIZED: '0',
  BUCKET: 'mykinship-dev-assets',
  ENV: 'dev'
};
